import * as React from 'react';

import { ApiContext } from 'context/ApiContext';
import {
  ICurrencyFormat,
  IDisplayByType,
  IHeadcountSpend,
  IHeadlinesResponse,
} from 'utils/types';
import { DISPLAY_BY, DISPLAY_BY_TO_API } from 'utils/constants';
import ColumnChart from 'components/ColumnChart/ColumnChart';
import { ApSimpleDropdown } from '@alixpartners/ui-components';
import { EXPORT_OPTIONS } from 'utils/constants';
import moment from 'moment';
import { getData } from './utils';
import {
  SectionWrapper,
  HeaderLabel,
  TopDataContent,
  HeaderTop,
} from '../Analysis.styles';

const SpendByJobContainer = ({
  displayBy,
  downloadSpendHeadcountData,
  headlines,
  format,
  headcountSpend,
  onExportChart,
  permanentContractorChecked,
  selectedSpendBy,
  serviceTowerL2,
  showSuccessNotification,
}: {
  displayBy: IDisplayByType;
  downloadSpendHeadcountData: (s: string) => Promise<any>;
  format: ICurrencyFormat;
  headlines: IHeadlinesResponse;
  headcountSpend: IHeadcountSpend[];
  onExportChart: (c: any, f: string) => void;
  permanentContractorChecked: boolean;
  selectedSpendBy?: string;
  serviceTowerL2?: string;
  showSuccessNotification: () => void;
  updateAppState: (p: { [key: string]: any }) => void;
}) => {
  if (!headcountSpend || headcountSpend.length === 0) {
    return null;
  }
  const chartRef = React.createRef<any>();
  const { revenue } = headlines.currentPeriod;
  const { categories, series } = getData({
    displayBy,
    headcountSpend,
    revenue,
  });

  const headerPrefix = {
    [DISPLAY_BY.COST]: 'Spend',
    [DISPLAY_BY.PERCENTAGE_OF_REVENUE]: 'Spend',
    [DISPLAY_BY.HEADCOUNT]: 'Headcount',
  }[displayBy];

  return (
    <SectionWrapper>
      <HeaderTop>
        <HeaderLabel>
          {serviceTowerL2
            ? serviceTowerL2
            : selectedSpendBy
            ? selectedSpendBy
            : ''}{' '}
          {headerPrefix} by Job Role
        </HeaderLabel>
        <ApSimpleDropdown
          iconName="outline_save_alt"
          onChange={(opt: any) => {
            if (opt.value === 'png') {
              onExportChart(
                chartRef && chartRef.current && chartRef.current.chart,
                `TXR_${
                  DISPLAY_BY_TO_API[displayBy]
                }-by-job-role-${moment().format()}`
              );
            } else if (opt.value === 'xlsx') {
              downloadSpendHeadcountData(DISPLAY_BY_TO_API[displayBy]).then(
                showSuccessNotification
              );
            }
          }}
          options={EXPORT_OPTIONS}
          label="Export"
        />
      </HeaderTop>
      <TopDataContent>
        <ColumnChart
          categories={categories}
          chartRef={chartRef}
          displayBy={displayBy}
          format={format}
          series={series}
        />
      </TopDataContent>
    </SectionWrapper>
  );
};

export default (props: any) => (
  <ApiContext.Consumer>
    {({ format }) => <SpendByJobContainer {...props} format={format} />}
  </ApiContext.Consumer>
);
